import { createContext, useContext } from 'react';
import { getTranslations } from './i18n';

export const I18nContext = createContext(getTranslations('es'));

export function useTranslation() {
  return useContext(I18nContext);
}
